import dubbingLandingData from "./dubbingLanding.json";
import type { SupportedLanguage } from "../locales";
import type { DubbingLanguagePair } from "./dubbingLanguagePairs";

export const DUBBING_LANDING_SEO_SLUG = "ai-video-voice-over-dubbing";

export type FaqItem = {
  question: string;
  answer: string;
};

type DubbingLandingContent = {
  heroTitle: string;
  title: string;
  description: string;
  keywords: string;
  faq: FaqItem[];
};

export const dubbingLandingContent = dubbingLandingData as Record<
  SupportedLanguage,
  DubbingLandingContent
>;

export function getDubbingLandingFaq(language: SupportedLanguage): FaqItem[] {
  return dubbingLandingContent[language]?.faq || dubbingLandingContent.en.faq;
}

export function getDubbingLandingSeo(language: SupportedLanguage) {
  return dubbingLandingContent[language] || dubbingLandingContent.en;
}

export function getDubbingPairLandingContent(
  language: SupportedLanguage,
  pair: DubbingLanguagePair
) {
  const base = getDubbingLandingSeo(language);
  const pairPhrase = `English to ${pair.target}`;

  if (language === "es" && pair.slug === "spanish") {
    return {
      ...base,
      heroTitle: "Doblaje. Traduce videos con voces de Ingles a Espanol",
      title: "Doblaje. Traduce vídeos con voces de Ingles a Españole | Vevi monsterr",
      description:
        "Doblaje con IA para traducir videos con voces de Ingles a Espanol. Convierte el audio de tus videos en minutos con voces naturales.",
      keywords: `${base.keywords}, doblaje ingles a espanol, traducir video ingles a espanol, doblaje ia espanol`,
      faq: base.faq.map((item) => ({
        ...item,
        question: `${item.question} (Ingles a Espanol)`,
      })),
    };
  }

  return {
    ...base,
    heroTitle: `${base.heroTitle}: ${pairPhrase}`,
    title: `${base.heroTitle}: ${pairPhrase} | VEVI Monster`,
    description: `${base.description} Optimized for ${pairPhrase} AI video voice over dubbing and localization.`,
    keywords: `${base.keywords}, english to ${pair.target.toLowerCase()} dubbing, english to ${pair.target.toLowerCase()} voice over`,
    faq: base.faq.map((item, index) => {
      const suffix = ` (${pairPhrase})`;
      if (index === 0) {
        return {
          question: `${item.question}${suffix}`,
          answer: `${item.answer} This page is focused on ${pairPhrase} video dubbing.`,
        };
      }
      if (index === 1) {
        return {
          question: `${item.question}${suffix}`,
          answer: item.answer,
        };
      }
      if (index === 2) {
        return {
          question: `${item.question}${suffix}`,
          answer: `${item.answer} Voice preservation quality depends on the source audio and target language.`,
        };
      }
      return {
        question: `${item.question}${suffix}`,
        answer: `${item.answer} ${pairPhrase} is supported in the same upload workflow.`,
      };
    }),
  };
}
